import styled from "styled-components";
import TextareaAutosize from "react-textarea-autosize";

export const Subtitle = styled.div`
  color: #5d6d7e;
`;

export const TextArea = styled(TextareaAutosize)``;
